import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { FormatInteger } from 'utils/format';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

const enhance = compose(injectIntl);

const VehicleMaxWeight = React.memo(({ intl, max_weight }) => {
  const t = intl.messages;
  return (
    !!max_weight && (
      <Fragment>
        <FormatInteger value={max_weight} /> {t.units.kg}
      </Fragment>
    )
  );
});

VehicleMaxWeight.propTypes = {
  intl: PropTypes.object.isRequired,
  max_weight: PropTypes.number,
};

export default enhance(VehicleMaxWeight);
